import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { goalsApi } from '../services/api';

export function useGoals() {
  return useQuery({
    queryKey: ['goals'],
    queryFn: goalsApi.getAll,
  });
}

export function useGoalProgress() {
  return useQuery({
    queryKey: ['goals', 'progress'],
    queryFn: goalsApi.getProgress,
  });
}

export function useUpdateGoals() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: goalsApi.updateAll,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['goals'] });
      toast.success('Metas atualizadas!');
    },
  });
}

export function useDeleteGoal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => goalsApi.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['goals'] });
      toast.success('Meta removida!');
    },
  });
}
